var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spinner", style: _vm.style }, [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner-frame" }, [
      _c("div", { staticClass: "spinner-proper" }, [
        _c("div", { staticClass: "spinner-inner" }),
      ]),
      _c("div", { staticClass: "spinner-frame" }, [
        _c("div", { staticClass: "spinner-proper" }, [
          _c("div", { staticClass: "spinner-inner" }),
        ]),
        _c("div", { staticClass: "spinner-frame" }, [
          _c("div", { staticClass: "spinner-proper" }, [
            _c("div", { staticClass: "spinner-inner" }),
          ]),
          _c("div", { staticClass: "spinner-frame" }, [
            _c("div", { staticClass: "spinner-proper" }, [
              _c("div", { staticClass: "spinner-inner" }),
            ]),
            _c("div", { staticClass: "spinner-frame" }, [
              _c("div", { staticClass: "spinner-proper" }, [
                _c("div", { staticClass: "spinner-inner" }),
              ]),
              _c("div", { staticClass: "spinner-frame" }, [
                _c("div", { staticClass: "spinner-proper" }, [
                  _c("div", { staticClass: "spinner-inner" }),
                ]),
                _c("div", { staticClass: "spinner-frame" }, [
                  _c("div", { staticClass: "spinner-proper" }, [
                    _c("div", { staticClass: "spinner-inner" }),
                  ]),
                  _c("div", { staticClass: "spinner-frame" }, [
                    _c("div", { staticClass: "spinner-proper" }, [
                      _c("div", { staticClass: "spinner-inner" }),
                    ]),
                    _c("div", { staticClass: "spinner-frame" }, [
                      _c("div", { staticClass: "spinner-proper" }, [
                        _c("div", { staticClass: "spinner-inner" }),
                      ]),
                      _c("div", { staticClass: "spinner-frame" }, [
                        _c("div", { staticClass: "spinner-proper" }, [
                          _c("div", { staticClass: "spinner-inner" }),
                        ]),
                        _c("div", { staticClass: "spinner-frame" }, [
                          _c("div", { staticClass: "spinner-proper" }, [
                            _c("div", { staticClass: "spinner-inner" }),
                          ]),
                          _c("div", { staticClass: "spinner-frame" }, [
                            _c("div", { staticClass: "spinner-proper" }, [
                              _c("div", { staticClass: "spinner-inner" }),
                            ]),
                            _c("div", { staticClass: "spinner-frame" }, [
                              _c("div", { staticClass: "spinner-proper" }, [
                                _c("div", { staticClass: "spinner-inner" }),
                              ]),
                              _c("div", { staticClass: "spinner-frame" }, [
                                _c("div", { staticClass: "spinner-proper" }, [
                                  _c("div", { staticClass: "spinner-inner" }),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }